import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-looker-dashboard',
  imports: [],
  template: `<div class="dashboard-wrapper h-100">
  <iframe 
    [src]="safeUrl" 
    width="100%" 
    height="100%" 
    frameborder="0" 
    style="border:0" 
    >
  </iframe>
</div>`,
  styleUrl: './looker-dashboard.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LookerDashboard implements OnInit {

  private readonly sanitizer = inject(DomSanitizer)

  // Sostituisci con l'URL che hai copiato al punto 4 della Fase 1
  lookerUrl: string = environment.lookerDashboardUrl;
  safeUrl!: SafeResourceUrl;

  // Inietta il DomSanitizer nel costruttore

  ngOnInit(): void {
    // Diciamo ad Angular: "Fidati, questo link è sicuro per essere usato in un iframe"
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.lookerUrl);
  }
}
